import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { ArrowRight2 } from 'iconsax-react';
import { Icon } from '@iconify/react';
const EventRegistrationLanguageSwitcher = ({ eventLanguages, selectedLanguageId, onLanguageChange, compact = false, variant = 'default' }) => {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const selectedLanguage = eventLanguages.find((l) => l.id === selectedLanguageId);
    const isDrawerVariant = variant === 'drawer';
    if (!eventLanguages.length)
        return null;
    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (languageId) => {
        handleClose();
        onLanguageChange(languageId);
    };
    const menu = (_jsx(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: handleClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        }, slotProps: {
            paper: {
                sx: {
                    borderRadius: 2,
                    mt: isDrawerVariant ? 0.5 : 1,
                    minWidth: isDrawerVariant ? 200 : 180
                }
            }
        }, children: eventLanguages.map((language) => isDrawerVariant ? (_jsxs(MenuItem, { selected: language.id === selectedLanguageId, onClick: (event) => {
                event.stopPropagation();
                handleSelect(language.id);
            }, children: [_jsx(Box, { component: 'img', src: language.flagUrl || '/assets/images/flags/us-flag.svg', alt: language.name, sx: { width: 20, height: 15, objectFit: 'cover', borderRadius: 0.5, mr: 1 } }), _jsx(Typography, { variant: 'body2', fontWeight: 500, color: '#00244D', children: language.name })] }, language.id)) : (_jsxs(MenuItem, { selected: language.id === selectedLanguageId, onClick: () => handleSelect(language.id), sx: { '&:hover': { backgroundColor: theme.palette.grey[50] } }, children: [_jsx(ListItemIcon, { children: _jsx(Box, { component: 'img', src: language.flagUrl || '/assets/images/flags/us-flag.svg', alt: language.name, sx: { width: 20, height: 15, objectFit: 'cover', borderRadius: 0.5 } }) }), _jsx(ListItemText, { primary: language.name, sx: {
                        '& .MuiListItemText-primary': {
                            fontSize: '14px',
                            fontWeight: 500,
                            color: theme.palette.grey[800]
                        }
                    } })] }, language.id))) }));
    if (isDrawerVariant) {
        return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: 'text', onClick: handleOpen, endIcon: _jsx(ArrowRight2, { size: 16, color: '#00244D' }), sx: {
                        justifyContent: 'space-between',
                        textTransform: 'none',
                        px: 0,
                        width: '100%',
                        color: '#00244D',
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: 1.2,
                        minHeight: 'auto',
                        py: '8px',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Box, { component: 'img', src: selectedLanguage?.flagUrl || '/assets/images/flags/us-flag.svg', alt: selectedLanguage?.name || 'language', sx: { width: 20, height: 15, objectFit: 'cover', borderRadius: 0.5 } }), _jsx(Typography, { component: 'span', sx: { fontSize: '14px', fontWeight: 500, color: 'inherit' }, children: selectedLanguage?.name || (selectedLanguage?.code || 'EN').toUpperCase() })] }) }), menu] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', size: compact ? 'small' : 'medium', onClick: handleOpen, endIcon: _jsx(Icon, { icon: 'mdi:chevron-down', width: 18 }), sx: {
                    borderColor: '#00244D33',
                    borderRadius: 2,
                    px: compact ? 1.5 : 2,
                    py: compact ? 0.75 : 1,
                    textTransform: 'none',
                    color: '#00244D',
                    backgroundColor: '#FFFFFF',
                    minWidth: compact ? 'auto' : 140,
                    '&:hover': {
                        borderColor: '#00244D66',
                        backgroundColor: '#FFFFFF'
                    }
                }, children: _jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, children: [_jsx(Box, { component: 'img', src: selectedLanguage?.flagUrl || '/assets/images/flags/us-flag.svg', alt: selectedLanguage?.name || 'language', sx: { width: 20, height: 15, objectFit: 'cover', borderRadius: 0.5 } }), !compact && (_jsx(Typography, { variant: 'body2', fontWeight: 500, children: selectedLanguage?.name || (selectedLanguage?.code || 'EN').toUpperCase() }))] }) }), menu] }));
};
export default EventRegistrationLanguageSwitcher;
